<template>
    <main>
        <div class="container feedback template-bg-gray"  v-bind:class="{'my-position-relative': isStatus}">
            <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
                <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
                    <div class="card form-wrapper text-center p-20">
                        <h4 class="template-custom-title">{{statusMsg}}</h4>
                    </div>
                </md-card-content>
            </md-card>
            <div class="row" v-if="!isStatus">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
                    <div class="loop_container bg-transparent update-request-form-common">
                        <div class="card form-wrapper">
                            <div class="community-logo">
                                <img v-if="$lodash.has(community.customSettings, 'logoURL') && community.customSettings && community.customSettings.logoURL" :src="community.customSettings.logoURL" :alt="(community && community.content && community.content.parameter2) ? community.content.parameter2 : 'Community Logo'" class="top-logo custom-logo">
                                <img v-else-if="community.customSettings && !community.customSettings.logoURL" :src="logoURL" :alt="(community && community.content && community.content.parameter2) ? community.content.parameter2 : 'Community Logo'" class="top-logo custom-logo">
                            </div>
                            <div class="feedback_container">
                                <div class='header-text text-center unsubscribepage-thankumsg'>
                                    <h1 class="template-title common-space-from-logo">Thank you!</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="list-inline text-center footer-links">
                        <li>
                            <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                        </li>
                        <li>
                            <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                            <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                        </li>
                        <li>
                            <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                            <a href="javascript:void(0)" v-else>Opt Out</a>
                        </li>
                    </ul>
                    <div class="unsubscribe-community-logo email-actionpage-flogo">
                        <a :href="(community.content && community.content.landingPageURL) || 'https://www.protopia.co'" target="_blank"><img :src="logoURL" alt='Community Logo'></a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script type="text/javascript">
import API from "../services/API";
import { sanitizeInput } from '../utils/sanitizer';

export default {
    data() {
        return {
            api: new API(),
            community: {
                    customSettings: {},
                    content: {
                        parameter2: '',
                        landingPageURL: '',
                        termsConditionsURL: '',
                        unsubscribePageURL: ''
                    }
            },
            styleBtn: {
                colorBackd: '#CBA8E0',
                colorBackdHover: '#9178A0',
                color: '#9178A0',
                colorHover: "#ffffff"
            },
            frequency: '',
            isEditing: false,
            advisorThankYou: '',
            isStatus: true,
            statusMsg: '',
            logoURL: process.env.LOGO_URL
        }
    },
    async created() {
        await this.updateLinkedInProfile().then(data => {
            if (this.getCookie("memberUpdateData")) {
                document.cookie = "memberUpdateData=" + this.getCookie("memberUpdateData") + "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
            let resp = data.data
            if (resp && resp.err) {
                this.isStatus = true;
                this.statusMsg = resp.err
            }
        }).catch(err => {
            console.log(err)
            this.isStatus = true;
            this.statusMsg = 'Something went Wrong!'
        })
    },
    methods: {
        getCookie(name) {
            let matches = document.cookie.match(new RegExp(name + '=([^;]+)'));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        updateLinkedInProfile: async function() {
            if (this.$route.query.code && this.$route.query.state) {
                if (this.$route.query.state == process.env.LINKEDIN_STATE_KEY) {
                    let memberUpdateData = this.getCookie('memberUpdateData')
                    if (memberUpdateData) {
                        memberUpdateData = JSON.parse(memberUpdateData)
                        // Sanitize the data
                        memberUpdateData = {
                            ...memberUpdateData,
                            communityContentParameter2: sanitizeInput(memberUpdateData.communityContentParameter2),
                            communityContentLandingPageURL: sanitizeInput(memberUpdateData.communityContentLandingPageURL),
                            communityContentTermsConditionsURL: sanitizeInput(memberUpdateData.communityContentTermsConditionsURL),
                            communityContentUnsubscribePageURL: sanitizeInput(memberUpdateData.communityContentUnsubscribePageURL),
                            code: sanitizeInput(this.$route.query.code)
                        }
                        localStorage.setItem('community_id', memberUpdateData.community);
                        this.community.customSettings = memberUpdateData.communityCustomSettings
                        this.community.content = {
                            parameter2: memberUpdateData.communityContentParameter2,
                            landingPageURL: memberUpdateData.communityContentLandingPageURL,
                            termsConditionsURL: memberUpdateData.communityContentTermsConditionsURL,
                            unsubscribePageURL: memberUpdateData.communityContentUnsubscribePageURL
                        }
                        let updateLinkedInProfileResponse = await this.api.post(`members/update-linkedin-profile`, {...memberUpdateData, ...{code: this.$route.query.code}})
                        this.isStatus = false;
                        return updateLinkedInProfileResponse;
                    } else {
                        this.statusMsg = 'Something went Wrong!'
                        this.isStatus = true;
                        return {
                            err: 'Something went Wrong!'
                        }
                    }
                }
            } else if (this.$route.query.error) {
                this.statusMsg = this.$route.query.error_description
                return {
                    err: this.$route.query.error_description
                }
            } else {
                this.statusMsg = 'Something went Wrong!'
                return {
                    err: 'Something went Wrong!'
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ThankYou.vue